import React, { useEffect, useLayoutEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import Dropdown from '../../common/Dropdown'
import PriceInput from '../../common/PriceInput'
import { TrashCanFull } from '../../../icons'
import { useWindowSize } from '../../../libs/hooks'

const FormPhysicalProductPrice = (props) => {
  const { t } = useTranslation()
  const isMobile = useWindowSize()[0] <= 768
  const { pricesFormData, productPricesErrors, countries, resetPricesErrors, updatePrices, isEditMode } = props
  const [discountOptions, setDiscountOptions] = useState([])

  useLayoutEffect(() => {
    if (pricesFormData.length === 0) {
      const newPrice = {
        amount: '',
        currencyCode: '',
        countryCode: '',
        trialBusinessRuleId: null, //A.S: Change to discount when implemented
      }

      updatePrices([newPrice])
    }
  }, [pricesFormData])

  useEffect(() => {
    if (props.priceDiscounts.length > 0) {
      const discounts = props.priceDiscounts.map((discount) => {
        return { id: discount.id, name: discount.name }
      })

      setDiscountOptions(discounts)
    }

    setDiscountOptions([{ id: 1, name: 'Test Discount' }])
  }, [props.priceDiscounts])

  const selectCountry = (countryCode, idx) => {
    const country = countries.find((c) => c.countryCode === countryCode)

    if (!country) {
      return
    }

    const updatedPrices = pricesFormData.map((price, index) => {
      if (index === idx) {
        return { ...price, countryCode: country.countryCode, currencyCode: country.currencyCode }
      }

      return price
    })

    updatePrices(updatedPrices)
  }

  const selectDiscountBusinessRule = (discountBusinessRuleId, idx) => {
    const updatedPrices = pricesFormData.map((price, index) => {
      if (index === idx) {
        return { ...price, trialBusinessRuleId: discountBusinessRuleId }
      }

      return price
    })

    updatePrices(updatedPrices)
  }

  const handleAddPrice = () => {
    const newPrice = {
      amount: '',
      currencyCode: '',
      countryCode: '',
      trialBusinessRuleId: null, //A.S: Change to discount when implemented
    }

    updatePrices([...pricesFormData, newPrice])
  }

  const handleRemovePrice = (index) => {
    const newPrices = pricesFormData.filter((price, idx) => idx !== index)

    resetPricesErrors()
    updatePrices(newPrices)
  }

  const handleChangeAmount = (amount, idx) => {
    const updatedPrices = pricesFormData.map((price, index) => {
      if (index === idx) {
        return { ...price, amount: amount }
      }

      return price
    })

    updatePrices(updatedPrices)
  }

  return (
    <>
      {pricesFormData.map((price, index) => (
        <div key={index} className={`prices-options-wrapper ${isMobile && 'flex-column'} ${isMobile && index !== 0 && 'with-big-margin-top'}`}>
          <div className="fixed-input-wrapper one-third-wrapper">
            <div className="input-label">
              {t('country')}
              <span className="required-mark">*</span>
            </div>
            <div className="title-with-action-wrapper-mobile">
              <Dropdown
                options={countries.map((option) => ({
                  key: option.countryCode,
                  value: option.countryName,
                  isDisabled: pricesFormData.some((p) => p.countryCode === option.countryCode),
                }))}
                initialSelectedKey={pricesFormData[index].countryCode}
                onChange={(item) => selectCountry(item.key, index)}
                hasError={productPricesErrors?.includes(`physical-${index}-countryCode`)}
                isDisabled={isEditMode && pricesFormData[index].id}
              />
              {isMobile && (
                <div className="delete-option-wrapper">
                  <TrashCanFull
                    onClick={() => {
                      handleRemovePrice(index)
                    }}
                  />
                </div>
              )}
            </div>
          </div>
          <div className={'fixed-input-wrapper one-third-wrapper' + (isMobile ? ' with-reduced-width' : '')}>
            <div className="input-label">
              {t('coltene_store.create_product.price')}
              <span className="required-mark">*</span>
            </div>
            <PriceInput
              value={price.amount}
              hasError={productPricesErrors?.includes(`physical-${index}-amount`)}
              onChange={(value) => handleChangeAmount(value, index)}
              currency={price.currencyCode}
            />
          </div>
          {/*A.S: Will be added once physical product discounts is implemented */}
          {/* <div className={"fixed-input-wrapper with-flex-grow" + (isMobile ? " with-reduced-width" : "")}>
            <div className="input-label">
              {t("coltene_store.create_product.business-rule")}
            </div>
            <Dropdown
              className={productPricesErrors?.includes(`physical-${index}-bussinesRule`) ? "input-error" : ""}
              eventItem={(e) => selectDiscountBusinessRuleInput(e, index)}
              toDisplayItem={(e) => selectDiscountBusinessRuleOptions(e, index)}
            />
          </div> */}
          {!isMobile && (
            <div className="delete-option-wrapper">
              <TrashCanFull
                onClick={() => {
                  handleRemovePrice(index)
                }}
              />
            </div>
          )}
        </div>
      ))}
      {pricesFormData.length < countries.length && (
        <div className="add-option-wrapper" onClick={() => handleAddPrice()}>
          {`+  ${t('coltene_store.create_product.add-new-country')}`}
        </div>
      )}
    </>
  )
}

function stateToProps({ businessRules }) {
  return {
    priceDiscounts: businessRules?.discounts || [],
  }
}

export default connect(stateToProps)(FormPhysicalProductPrice)
